import type { UnlikelyProduct } from "@unlikelystudio/commerce-connector"

import type { I18nLocale } from "~/lib/i18n/types"
import { getMarket } from "~/lib/i18n/utils/get-i18n"

// We need to add a char prefix because there are side effects
// When the filters values are numbers (we dont really know why) - the same applies to the sizes filter
export const DISCOUNT_REPLACER = "p"
// We need to remove the percentage sign from the discount value
// Because it creates an error when used in the URL params
export const DISCOUNT_PERCENT_CHAR = "%"

/**
 * Darel handles discount filters based on a product tag that changes depending on the market
 * here are the possible values:
 * France -> Promotion|10% (the value after the pipe is the discount percentage)
 * International (aka Europe) -> Promotion_EUR|10%
 * CH -> Promotion_CH|10%
 * UK -> Promotion_UK|10%
 * US -> US|10%
 */
export function processDiscount({ locale, product }: { locale: I18nLocale; product: UnlikelyProduct }) {
  const market = getMarket(locale)
  const tagSuffix = market === "France" ? "" : market === "International" ? "_EUR" : `_${market}`

  const discountTag = product?.tags?.find((tag) => {
    return tag?.startsWith(`Promotion${tagSuffix}|`)
  })

  const [_, discount] = discountTag?.split("|") ?? []

  return discount ? `${discount?.replaceAll(DISCOUNT_PERCENT_CHAR, DISCOUNT_REPLACER)}` : null
}
